import { render, staticRenderFns } from "./wlmz-online-report.vue?vue&type=template&id=72f1c675&scoped=true&"
import script from "./wlmz-online-report.vue?vue&type=script&lang=js&"
export * from "./wlmz-online-report.vue?vue&type=script&lang=js&"
import style0 from "./wlmz-online-report.vue?vue&type=style&index=0&id=72f1c675&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1c675",
  null
  
)

export default component.exports